/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { resourceUpdated, selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import { changeTopNavigationElements } from "../../slices/navigationPanel/navigationPanelSlice";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import Spinner from "../../components/Spinner";
import { ReorganizeSectionsModal } from "../ReorderCompositionSections";
import createCompositionTableDict from "../compositionResourceFunctions/createCompositionTableDict";
import SummaryOfNetEffectTable from "./SummaryOfNetEffectTable";
//import HealthImpactForestPlotColorful from "./HealthImpactForestPlotColorful";
//import HealthImpactForestPlot from "./HealthImpactForestPlot";
import ColorSchemeToggle from "../../components/ColorSchemeToggle";
import HealthImpactForestPlotEnhanced from "./HealthImpactForestPlotEnhanced";
import getNetEffectPointEstimate from "../compositionResourceFunctions/getNetEffectPointEstimate";
import getNetEffectEstimate from "../compositionResourceFunctions/getNetEffectEstimate";
import generateNarrativeFromSummaryOfFindingsTable from "../compositionResourceFunctions/generateNarrativeFromSummaryOfFindingsTable";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../../datatypeComponents/NarrativeEntry";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { changeComparativeEvidenceMap, selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import TopSectionSliceDisplay from "./TopSectionSliceDisplay";
import { loadTopSections, selectAllTopSections, selectTopSectionsStatus, topSectionAdded } from "../../slices/topSections/topSectionsSlice";
import { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference, displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import { useNavigate } from "react-router-dom";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";

const SummaryOfNetEffectDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const allTopSections = useSelector(selectAllTopSections);
    const topSectionsStatus = useSelector(selectTopSectionsStatus);
    const sections = allTopSections.map(entity => { return entity.revisedSection });

    const [compositionResourceState, setCompositionResourceState] = useState({});
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState("");
    const [editSectionModal, setEditSectionModal] = useState({ "openModal": false });
    const [sectionNavigationElementIds, setSectionNavigationElementIds] = useState([]);
    const [sectionsReorganizedState, setSectionsReorganizedState] = useState({});
    const [addSectionState, setAddSectionState] = useState({
        "sectionTitle": "", "addSectionClicked": false
    });
    const [remountTable, setRemountTable] = useState(0);
    const [findingsSectionIndexState, setFindingsSectionIndexState] = useState(null);
    const [netEffectEstimateSectionIndexState, setNetEffectEstimateSectionIndexState] = useState(null);
    const [subjectState, setSubjectState] = useState({});
    const [netBenefitCalculatorIntroductionState, setNetBenefitCalculatorIntroductionState] = useState({});

    useEffect(() => {
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setCompositionResourceState(olderVersionJson);
                let topNavigationElements = ["Summary", "Summary Table"];
                let sectionHeaderNavigationElements = [];
                if (Array.isArray(olderVersionJson.section)) {
                    for (const section of olderVersionJson.section) {
                        let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                        let sectionFocus = section?.focus?.display || section?.focus?.reference;
                        let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                        topNavigationElements.push(sectionHeader);
                        sectionHeaderNavigationElements.push(sectionHeader);
                    }
                }
                dispatch(changeTopNavigationElements(topNavigationElements));
                const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                    let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                    return id;
                }))
                setSectionNavigationElementIds(sectionNavigationIds);
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson?.id) {
            setCompositionResourceState(JSON.parse(JSON.stringify(resourceJson)));
            if (Array.isArray(resourceJson.subject) && resourceJson.subject[0]) {
                setSubjectState({ referenceInstance: resourceJson.subject[0] });
            }
            if (Array.isArray(resourceJson.relatesTo)) {
                for (const relatesTo of resourceJson.relatesTo) {
                    if (relatesTo.type?.text === "Introduction for Net Benefit Calculator") {
                        let netBenefitCalculatorIntroduction = relatesTo.targetMarkdown || "";
                        setNetBenefitCalculatorIntroductionState({ "introduction": netBenefitCalculatorIntroduction });
                        break;
                    }
                }
            }
            setSectionsReorganizedState({ "reorganized": false, "section": JSON.parse(JSON.stringify(resourceJson.section)) });
            let topNavigationElements = ["Summary", "Summary Table"];
            let sectionHeaderNavigationElements = [];
            if (Array.isArray(resourceJson.section)) {
                for (const sectionIndex in resourceJson.section) {
                    let section = resourceJson.section[sectionIndex];
                    let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                    let sectionFocus = section?.focus?.display || section?.focus?.reference;
                    let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                    topNavigationElements.push(sectionHeader);
                    sectionHeaderNavigationElements.push(sectionHeader);
                    if (section?.code?.coding?.[0]?.code === "summary-of-findings" &&
                        section.section.length > 0
                    ) {
                        setFindingsSectionIndexState(sectionIndex);
                    }
                    if (section?.code?.coding?.[0]?.code === "net-effect-estimate") {
                        setNetEffectEstimateSectionIndexState(sectionIndex);
                    }
                }
            }
            dispatch(changeTopNavigationElements(topNavigationElements));
            const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                return id;
            }))
            setSectionNavigationElementIds(sectionNavigationIds);
            let combinedDictionary = {};
            for (const entry of resourceCollection) {
                combinedDictionary[entry.id] = entry.revisedResourceJson;
            }
            if (Array.isArray(compositionResourceState.contained) && compositionResourceState.contained.length > 0) {
                for (const item of compositionResourceState.contained) {
                    combinedDictionary[item.id] = item;
                }
            }
            let body = {
                "compositionId": foi,
                "compositionTitle": resourceJson.title || resourceJson.name || parentResourceDetail.displayTitle,
                "researchStudyReference": {},
                "populationReference": {},
                "populationDescriptionGroupReference": {},
                "analyzedGroupReference": {},
                "enrolledGroupReference": {},
                "interventionGroupReference": {},
                "interventionDescriptionReference": {},
                "comparatorGroupReference": {},
                "comparatorDescriptionReference": {},
                "groupAssignmentReference": {},
                "synthesisPopulationReference": {},
                "synthesisInterventionDescriptionReference": {},
                "synthesisComparatorDescriptionReference": {},
                "screenedGroupReference": {},
                "excludedGroupReference": {},
                "groupReferencesDictionary": {},
                "outcomeMeasuresReportReference": {},
                "participantFlowReportReference": {},
                "baselineMeasuresReportReference": {},
                "summaryOfFindingsReference": {},
                "outcomeMeasures": [],
                "baselineMeasures": [],
                "participantFlowMeasures": [],
                "outcomeVariablesListReference": {},
                "participantFlowVariablesListReference": {},
                "baselineVariablesListReference": {},
                "combinedDictionary": combinedDictionary,
                "evidenceDisplayDictionary": {}
            };
            dispatch(changeComparativeEvidenceMap(body));
        }
    }, [resourceJson]);

    useEffect(() => {
        if (topSectionsStatus === "succeeded" && allTopSections?.length > 0 && compositionResourceState &&
            Object.keys(compositionResourceState).length > 0
        ) {
            let newCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (newCompositionSection.length > 0) {
                let tableData = createCompositionTableDict({ section: newCompositionSection });
                if (tableData?.Labels) {
                    let netEffectPointEstimate = getNetEffectPointEstimate(compositionResourceState) || null;
                    let netEffectEstimate = getNetEffectEstimate(compositionResourceState) || null;
                    let generatedNarrative = generateNarrativeFromSummaryOfFindingsTable(tableData,
                        netEffectPointEstimate, netEffectEstimate);
                    setGeneratedNarrativeState(generatedNarrative);
                }
                if (editMode && resourceJson) {
                    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                    let previousInitialValue = null;
                    let previousFinalValue = null;
                    previousInitialValue = newResourceDetail.resourceJson.section;
                    previousFinalValue = newResourceDetail.revisedResourceJson.section;
                    newResourceDetail.revisedResourceJson.section = newCompositionSection;
                    if (newCompositionSection !== undefined &&
                        JSON.stringify(previousFinalValue) !== JSON.stringify(newCompositionSection) &&
                        !(!previousInitialValue &&
                            Array.isArray(newCompositionSection) &&
                            (newCompositionSection.length === 0 ||
                                (newCompositionSection.length === 1 &&
                                    !newCompositionSection[0])
                            )
                        )) {
                        console.log("resourceUpdate for Composition.section");
                        dispatch(resourceUpdated(newResourceDetail));
                        setRemountTable(prevState => prevState + 1);
                    }
                }
            }
        }
    }, [allTopSections, compositionResourceState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(compositionResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [compositionResourceState.text]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = compositionResourceState.title;
            newResourceDetail.displayTitle = compositionResourceState.title ||
                compositionResourceState.name || newResourceDetail.displayTitle;
            if (compositionResourceState.title !== undefined &&
                previousFinalValue !== compositionResourceState.title) {
                console.log("resourceUpdate for Composition.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "title",
                    previousInitialValue,
                    compositionResourceState.title);
            }
        }
    }, [compositionResourceState.title]);

    useEffect(() => {
        if (subjectState.referenceInstance) {
            setCompositionResourceState(prevState => {
                let newSubject =  [];
                if (prevState.subject) {
                    newSubject = JSON.parse(JSON.stringify(prevState.subject));
                }
                if (newSubject[0] !== undefined) {
                    newSubject[0] = subjectState.referenceInstance;
                } else {
                    newSubject.push(subjectState.referenceInstance);
                }
                return {
                    ...prevState,
                    subject: newSubject
                };
            });
        }
    }, [subjectState.referenceInstance]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(compositionResourceState, "subject", "ArrayOfReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [compositionResourceState.subject]);

    useEffect(() => {
        if (netBenefitCalculatorIntroductionState.introduction) {
            let introductionRelatesTo = {
                "type": { "text": "Introduction for Net Benefit Calculator" },
                "targetMarkdown": netBenefitCalculatorIntroductionState.introduction
            }
            setCompositionResourceState(prevState => {
                let newRelatesTo = [];
                if (prevState.relatesTo) {
                    newRelatesTo = JSON.parse(JSON.stringify(prevState.relatesTo));
                }
                if (newRelatesTo.length === 0) {
                    newRelatesTo.push(introductionRelatesTo);
                } else {
                    let introductionRelatesToFound = false;
                    for (let relatesTo of newRelatesTo) {
                        if (relatesTo.type?.text === "Introduction for Net Benefit Calculator") {
                            introductionRelatesToFound = true;
                            relatesTo.targetMarkdown = netBenefitCalculatorIntroductionState.introduction;
                        }
                    }
                    if (!introductionRelatesToFound) {
                        newRelatesTo.push(introductionRelatesTo);
                    }
                }
                return {
                    ...prevState,
                    relatesTo: newRelatesTo
                };
            });
        }
    }, [netBenefitCalculatorIntroductionState.introduction]);

    useEffect(() => {
        if (editMode && resourceJson && netBenefitCalculatorIntroductionState.introduction) {
            updateElement(compositionResourceState, "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [compositionResourceState.relatesTo]);

    useEffect(() => {
        if (editMode && resourceJson && sectionsReorganizedState.reorganized &&
            Array.isArray(sectionsReorganizedState.section) && sectionsReorganizedState.section.length > 0) {
            setSectionsReorganizedState(prevState => { return { ...prevState, "reorganized": false } });
            let oldCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (JSON.stringify(oldCompositionSection) !== JSON.stringify(sectionsReorganizedState.section)) {
                let topSectionArray = sectionsReorganizedState.section.map((section, sectionIndex) => {
                    return {
                        id: sectionIndex,
                        displayTitle: section.title ||
                            simpleDisplayStringFromFHIRCodeableConcept(section.code) ||
                            displayStringFromFHIRReference(section.focus) || "Untitled Section",
                        compositionId: foi,
                        productFamily: "SummaryOfNetEffect",
                        initialSection: section,
                        revisedSection: section
                    };
                });
                let topSectionsBody = { topSections: topSectionArray };
                dispatch(loadTopSections(topSectionsBody));
                console.log("sectionsReorganized so resourceUpdate for Composition.section");
            }
            let previousInitialValue = parentResourceDetail.resourceJson.section || null;
            updateChangeReport(dispatch, resourceChanges, parentResourceDetail.id,
                "ArrayOfSection",
                "section",
                previousInitialValue,
                sectionsReorganizedState.section);
        }
    }, [sectionsReorganizedState]);

    useEffect(() => {
        if (editMode && resourceJson && addSectionState.addSectionClicked &&
            addSectionState.sectionTitle) {
            let sectionLength = allTopSections.length;
            let sectionBody = {
                id: sectionLength,
                displayTitle: addSectionState.sectionTitle,
                compositionId: foi,
                productFamily: "SummaryOfNetEffect",
                initialSection: { "title": addSectionState.sectionTitle },
                revisedSection: { "title": addSectionState.sectionTitle }
            }
            dispatch(topSectionAdded(sectionBody));
            console.log("addSectionState so resourceUpdate for Composition.section");
            updateChangeReport(dispatch, resourceChanges, parentResourceDetail.id,
                "CompositionSection",
                "section[" + sectionLength + "]",
                null,
                { "title": addSectionState.sectionTitle });
            setAddSectionState({
                "sectionTitle": "", "addSectionClicked": false
            });
        }
    }, [addSectionState]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div style={{ marginTop: "12px" }}>
        {(topSectionsStatus === "succeeded" && allTopSections?.length > 0 &&
            compositionResourceState && Object.keys(compositionResourceState).length > 0
        ) &&
            <>
                <h3 id="summary">Summary</h3>
                <div style={{ marginLeft: "24px" }}>
                    {
                        editMode ?
                            <>
                                <h4>An overall summary for the Summary of Net Effect Report</h4>
                                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                                    generatedNarrative={generatedNarrativeState} startCollapsed
                                    startingValue={compositionResourceState.text}
                                    calledFrom={"SummaryOfNetEffectDisplay"}
                                    setResourceState={setCompositionResourceState} />
                                <h4>An overall summary for use with the Net Benefit Calculator</h4>
                                <MarkdownEntry elementName='introduction' fieldLabel='Net Benefit Calculator introduction'
                                    startingValue={netBenefitCalculatorIntroductionState.introduction}
                                    setResourceState={setNetBenefitCalculatorIntroductionState} />
                                <h4>Subject (consider General Population if default value desired)</h4>
                                <ReferenceEntry elementName="referenceInstance" fieldLabel="Subject"
                                    startingResourceType="Group" referencedResourceTypes={["Group"]}
                                    startingValue={subjectState.referenceInstance} enableCreation={true}
                                    setResourceState={setSubjectState} deletable startCollapsed />
                            </>
                            :
                            <>
                                <h4>An overall summary for the Summary of Net Effect Report</h4>
                                {(compositionResourceState.text?.div && compositionResourceState.text.status && compositionResourceState.text.status !== "empty") ?
                                    <DisplayFromFHIRXhtml xhtml={compositionResourceState.text.div} />
                                    : <p>[Narrative summary not generated.]</p>}
                                {netBenefitCalculatorIntroductionState.introduction &&
                                    <>
                                        <h4>An overall summary for use with the Net Benefit Calculator</h4>
                                        <DisplayFromFHIRMarkdown markdown={netBenefitCalculatorIntroductionState.introduction} />
                                    </>}
                                {compositionResourceState.subject?.[0] &&
                                    <>
                                        <h4>Subject</h4>
                                        <DisplayFromFHIRReference reference={compositionResourceState.subject[0]} />
                                    </>
                                }
                            </>
                    }
                </div>
                <h3 id="summary-table">Summary Table</h3>
                <>
                    <div>
                        <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }}
                            className="formButton"
                            content="Use the Net Benefit Calculator" positive
                            onClick={() => {
                                navigate("/NetBenefitCalculator/" + foi, { replace: true });
                            }}
                        />
                        &nbsp;&nbsp;
                        <p>&nbsp;&nbsp;An interactive form which does not alter the publicly available content and lets you modify the relative importance of outcomes with your personal values.</p>
                    </div>
                    <br />
                    <br />
                    <SummaryOfNetEffectTable key={remountTable}
                        subject={compositionResourceState.subject?.[0]}
                        findingsSectionIndex={findingsSectionIndexState}
                        netEffectEstimateSectionIndex={netEffectEstimateSectionIndexState} />
                </>
                <br />
                <ColorSchemeToggle />
                <br />
                <HealthImpactForestPlotEnhanced key={remountTable + "Forest"}
                    findingsSectionIndex={findingsSectionIndexState}
                    netEffectEstimateSectionIndex={netEffectEstimateSectionIndexState} />
                {editMode && <div>
                    <Button className="formButton" style={{ margin: "0px" }}
                        content="Reorganize Sections" compact
                        onClick={() => { setEditSectionModal({ "openModal": true }) }} />
                    <br />
                </div>}
                {(editSectionModal.openModal) &&
                    <>
                        <ReorganizeSectionsModal
                            editSectionModal={editSectionModal}
                            setEditSectionModal={setEditSectionModal}
                            sectionsReorganizedState={sectionsReorganizedState}
                            setSectionsReorganizedState={setSectionsReorganizedState}
                        />
                    </>}
                <div>
                    {sections && <>
                        {(sections?.length > 0) &&
                            sections.map((section, sectionIndex) => {
                                return <div key={sectionIndex}>
                                    <TopSectionSliceDisplay foi={foi}
                                        setCompositionResourceState={setCompositionResourceState}
                                        sectionIndex={sectionIndex}
                                        resourceReferenceMap={comparativeEvidenceMap}
                                        sectionNavigationElementIds={sectionNavigationElementIds} />
                                    <br />
                                </div>
                            })}
                        {editMode &&
                            <>
                                <Button style={{ color: "#000000", width: "130px", float: "left" }}
                                    className="formButton"
                                    content="+ Add Section"
                                    onClick={() => {
                                        setAddSectionState({
                                            "sectionTitle": "Replace with Proper Section Title",
                                            "addSectionClicked": true
                                        });
                                    }}
                                />
                            </>}
                    </>}
                </div>
            </>}
    </div>
}

export default SummaryOfNetEffectDisplay;